import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  template: '',
  selector: 'app-legacy-loader',
})
export class LegacyLoaderComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    // if both produktID (with k) and productid exist, productID (with c) is chosen
    let legacyId = Number(this.route.snapshot.queryParamMap.get('produktid'));

    if (Number(this.route.snapshot.queryParamMap.get('productid')) != 0) {
      legacyId = Number(this.route.snapshot.queryParamMap.get('productid'));
    }

    const params: any = {};

    this.GetUrlIdByLegacyId(legacyId).subscribe({
      next: (next) => {
        if (next.status === 200) {
          //now handle all legacy parameters individually and redirect accordingly
          this.route.queryParamMap.subscribe((paramMap) => {
            paramMap.keys.forEach((key) => {
              switch (key) {
                case 'productid':
                case 'produktid':
                  //skip it, thats our legacyID and is already converted to next.body
                  break;
                default:
                  params[key] = paramMap.get(key);
              }
            });

            this.router.navigate([next.body], {
              queryParams: params,
            });
          });
        } else {
          this.redirectToOldRechner();
        }
      },
      error: () => {
        this.redirectToOldRechner();
      },
    });
  }

  redirectToOldRechner(): void {
    const oldRechnerBaseURL = environment.legacyRechnerBaseURL;

    window.location.replace(
      oldRechnerBaseURL +
        location.pathname.slice(1).replace('tarifrechner/', '') +
        location.search
    );
  }

  public GetUrlIdByLegacyId(
    legacyId: number
  ): Observable<HttpResponse<number>> {
    const url = `${environment.apiUrl}/api/Data/legacy/${legacyId}`;
    return this.http.get<number>(url, { observe: 'response' });
  }
}
